﻿/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable selector-max-compound-selectors */
@import '../../sass/bootstrap/pre-default';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';
@import '../../sass/colors';
@import '../../sass/spacers';

$what-intent-color-light: $vt-white;
$what-intent-color-black: $vt-black;

[data-whatintent='mouse'] :focus,
[data-whatintent='mouse'] input[type='radio']:focus ~ label::before {
  outline: none;
}

[data-whatintent='keyboard'] :focus,
[data-whatintent='keyboard'] input[type='radio']:focus,
[data-whatintent='keyboard'] input[type='checkbox']:focus {
  outline: solid $what-intent-color-black !important;
  box-shadow: none;
  border-color: inherit;
}

[data-whatintent='keyboard'] .outline-light :focus,
[data-whatintent='keyboard'] .outline-light input[type='radio']:focus,
[data-whatintent='keyboard'] .outline-light input[type='checkbox']:focus {
  outline: solid $what-intent-color-light !important;
}

[data-whatintent='keyboard'] .outline-semi-light :focus,
[data-whatintent='keyboard'] .outline-semi-light input[type='radio']:focus,
[data-whatintent='keyboard'] .outline-semi-light input[type='checkbox']:focus {
  outline: solid $what-intent-color-light !important;
}

[data-whatintent='keyboard'] .outline-normal :focus,
[data-whatintent='keyboard'] .outline-normal input[type='radio']:focus,
[data-whatintent='keyboard'] .outline-normal input[type='checkbox']:focus {
  outline: solid $what-intent-color-black !important;
}

// Special case for information banner
[data-whatintent='keyboard'] .information-banner.outline-normal :focus {
  outline-offset: -3px !important;
}

// Special case for the selectable square
[data-whatintent='keyboard'] .selectable-square:has(input[type='radio']:focus) {
  outline: solid $what-intent-color-black !important;
}

[data-whatinput='touch'] :focus,
[data-whatinput='touch'] input[type='radio']:focus ~ label::before,
[data-whatinput='touch'] input[type='checkbox']:focus ~ label::before {
  outline: none;
}

[data-whatinput='touch'] {
  .header-desktop {
    :focus {
      outline: none;
    }
  }
}
